module.exports = __webpack_public_path__ + "3946e33162a88db7c4c49bfd4971d53b.jpg";